export default {
      id: "compass-usage",
      viewBox: "0 0 60 60",
      url: __webpack_public_path__ + "icons/symbols.67516b0a.svg#compass",
      toString: function () {
        return this.url;
      }
    }